import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/App";

export default function CtaBand() {
  return (
    <section data-testid="dark-cta-band" className="relative bg-[#090D16] py-20 sm:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_60%_at_50%_100%,rgba(16,185,129,0.18),transparent)] pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
            Book a call. <span className="text-emerald-400">See what's possible.</span>
          </h2>
        </Reveal>
        <Reveal>
          <p className="mt-5 text-base sm:text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed">
            Let us take the pressure off your team, fill your pipeline and drive
            sustainable growth for your business.
          </p>
        </Reveal>
        <Reveal>
          <button
            data-testid="dark-cta-book-btn"
            onClick={() => scrollToId("contact")}
            className="group mt-9 inline-flex items-center gap-2.5 bg-emerald-500 hover:bg-emerald-400 text-[#090D16] font-semibold px-9 py-4 rounded-xl shadow-lg shadow-emerald-500/25 transition-all hover:shadow-xl hover:-translate-y-0.5"
          >
            Book Your Strategy Call Now
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </button>
        </Reveal>
        <Reveal>
          <p className="mt-6 font-mono-accent text-[11px] uppercase tracking-[0.3em] text-slate-500">
            People • Relationships • Opportunities • Growth
          </p>
        </Reveal>
      </div>
    </section>
  );
}
